import { useState } from 'react';
import { MapPin } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { CityPicker } from '@/components/listings/detail/SellerLocationCard';
import { useVisitorCity } from '@/hooks/useVisitorCity';

export function ListCityPicker() {
  const { city, setCity } = useVisitorCity();
  const [open, setOpen] = useState(false);
  return <>
    <Button type="button" variant="outline" size="sm" onClick={() => setOpen(true)} className="gap-2 text-primary border-primary/40">
      <MapPin size={16} aria-hidden="true" />
      {city ? `Distanța față de ${city.city} · schimbă orașul` : 'Setează orașul tău pentru a vedea distanța'}
    </Button>
    {open && <CityPicker current={city} onClose={() => setOpen(false)} onSelect={(value) => { setCity(value); setOpen(false); }} onClear={() => { setCity(null); setOpen(false); }} />}
  </>;
}